import { memo } from 'react';
import PropTypes from 'prop-types';
import { Col, Container, Row } from 'react-bootstrap';


const BzTabsContainer = ({ className, containerClassName = "", rowClassname = "", children, ...props }) => {
    return (
        <Container fluid className={`p-0 ${containerClassName}`}>
            <Row className={`g-0 ${rowClassname}`}>
                <Col>
                    <div className={`tab-content ${className}`} {...props}>
                        {children}
                    </div>
                </Col>
            </Row>
        </Container>
    );
};

BzTabsContainer.propTypes = {
    className: PropTypes.string,
};

BzTabsContainer.defaultProps = {
    className: ""
};


export default memo(BzTabsContainer);
